import { render } from "./RegisterEstate.vue?vue&type=template&id=5c5dccf2&scoped=true"
import script from "./RegisterEstate.vue?vue&type=script&lang=js"
export * from "./RegisterEstate.vue?vue&type=script&lang=js"

import "./RegisterEstate.vue?vue&type=style&index=0&id=5c5dccf2&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5dccf2"]])

export default __exports__